// Progress steps of the click-through (screens 2–6, labels: dict.progress).
// Kept out of FlowShort.tsx so the articles overview (src/articles.ts) can
// show the step count without pulling the lazy-loaded flow into its bundle.
export const PROGRESS: ('warum' | 'rechner' | 'ablauf' | 'weiterzahlen' | 'verstanden')[] = [
  'warum',
  'rechner',
  'ablauf',
  'weiterzahlen',
  'verstanden',
];
